/* eslint-disable */
import { CHOCOBO_BASE_STATS } from '@/constants/chocoboConstants'
import { Chocobo } from '@/models/chocobos'

const CHOCOBO_PREFIXES = [
  // Original names
  'Cloud', 'Star', 'Moon', 'Sun', 'Sky', 'Dawn', 'Dusk', 'Storm', 'Wind', 'Rain',
  'Flash', 'Swift', 'Light', 'Shadow', 'Bright', 'Dust', 'Crystal', 'Silver', 'Golden',
  'Fire', 'Ice', 'Thunder', 'River', 'Ocean', 'Mountain', 'Forest', 'Meadow', 'Spring',
  'Summer', 'Autumn', 'Winter', 'Morning', 'Evening', 'Midnight', 'Twilight',
  
  // FF Character Names
  'Tifa', 'Barret', 'Aerith', 'Vincent', 'Yuffie', 'Cid', 'RedXIII', 'Sephiroth',
  'Zack', 'Cissnei', 'Genesis', 'Angeal', 'Rufus', 'Reno', 'Rude', 'Elena',
  'Squall', 'Rinoa', 'Quistis', 'Zell', 'Selphie', 'Irvine', 'Seifer', 'Edea',
  'Tidus', 'Yuna', 'Wakka', 'Lulu', 'Auron', 'Kimahri', 'Rikku', 'Jecht',
  'Vaan', 'Ashe', 'Balthier', 'Fran', 'Basch', 'Penelo', 'Gabranth', 'Cid',
  'Lightning', 'Snow', 'Vanille', 'Sazh', 'Hope', 'Fang', 'Serah', 'Noel',
  
  // Nature/Element themed
  'Frost', 'Blaze', 'Ember', 'Coral', 'Pearl', 'Jade', 'Ruby', 'Sapphire',
  'Onyx', 'Opal', 'Quartz', 'Amber', 'Topaz', 'Garnet', 'Amethyst', 'Diamond',
  'Azure', 'Crimson', 'Scarlet', 'Violet', 'Indigo', 'Ivory', 'Ebony', 'Ash',
  'Cedar', 'Birch', 'Oak', 'Pine', 'Willow', 'Maple', 'Elm', 'Redwood',
  'Sage', 'Basil', 'Mint', 'Rose', 'Lily', 'Iris', 'Daisy', 'Tulip',
  
  // Mythological/Fantasy
  'Phoenix', 'Dragon', 'Griffin', 'Pegasus', 'Unicorn', 'Sphinx', 'Hydra', 'Chimera',
  'Atlas', 'Orion', 'Vega', 'Sirius', 'Polaris', 'Castor', 'Pollux', 'Rigel',
  'Neo', 'Zephyr', 'Aether', 'Cosmos', 'Nebula', 'Galaxy', 'Comet', 'Meteor',
  'Titan', 'Golem', 'Sylph', 'Ifrit', 'Shiva', 'Ramuh', 'Bahamut', 'Leviathan',
  
  // Weather/Sky
  'Cirrus', 'Nimbus', 'Stratus', 'Cumulus', 'Drizzle', 'Mist', 'Fog', 'Hail',
  'Gale', 'Breeze', 'Hurricane', 'Typhoon', 'Cyclone', 'Tempest', 'Vortex', 'Whirlwind',
  
  // Speed/Racing themed
  'Turbo', 'Nitro', 'Rocket', 'Bullet', 'Arrow', 'Dart', 'Bolt', 'Zoom',
  'Rush', 'Blur', 'Streak', 'Velocity', 'Tempo', 'Rhythm', 'Beat', 'Pulse'
]

const CHOCOBO_SUFFIXES = [
  // Original movement/racing themed
  'feather', 'wing', 'dancer', 'runner', 'jumper', 'chaser', 'racer', 'sprinter',
  'dream', 'heart', 'soul', 'spirit', 'whisper', 'song', 'melody', 'breeze',
  'dash', 'flash', 'spark', 'flare', 'beam', 'glow', 'shine', 'light',
  'step', 'stride', 'glide', 'flight', 'soar', 'drift', 'float', 'rush',
  
  // Action/Movement themed
  'bound', 'leap', 'spring', 'charge', 'burst', 'blitz', 'streak', 'zoom',
  'sweep', 'dive', 'climb', 'rise', 'fall', 'turn', 'spin', 'whirl',
  'gallop', 'trot', 'pace', 'stride', 'march', 'walk', 'stroll', 'wander',
  
  // Mythological/Fantasy
  'blade', 'sword', 'shield', 'crown', 'throne', 'castle', 'tower', 'gate',
  'spell', 'charm', 'magic', 'rune', 'crystal', 'gem', 'orb', 'shard',
  'legend', 'myth', 'tale', 'saga', 'epic', 'lore', 'fable', 'story',
  
  // Nature/Element
  'flame', 'frost', 'storm', 'wind', 'rain', 'snow', 'mist', 'dew',
  'leaf', 'petal', 'bloom', 'bud', 'seed', 'root', 'branch', 'bark',
  'stone', 'rock', 'sand', 'dust', 'earth', 'clay', 'ore', 'metal',
  
  // Character/Emotion
  'hope', 'joy', 'peace', 'calm', 'grace', 'pride', 'honor', 'valor',
  'courage', 'strength', 'power', 'might', 'force', 'will', 'spirit', 'essence',
  'wisdom', 'knowledge', 'truth', 'faith', 'trust', 'love', 'care', 'kindness',
  
  // Time/Celestial
  'dawn', 'dusk', 'noon', 'night', 'day', 'hour', 'moment', 'time',
  'star', 'moon', 'sun', 'sky', 'cloud', 'horizon', 'zenith', 'eclipse',
  'season', 'spring', 'summer', 'autumn', 'winter', 'year', 'age', 'era'
]

// Traditional chocobo names
const TRADITIONAL_NAMES = [
  // Original traditional names
  'Boko', 'Choco', 'Koko', 'Moko', 'Poco', 'Loco', 'Bobby', 'Sunny', 'Lucky',
  'Zippy', 'Speedy', 'Sparky', 'Fluffy', 'Puffy', 'Buddy', 'Chibi', 'Kweh',
  'Wark', 'Dash', 'Flash', 'Blitz', 'Comet', 'Nova', 'Luna', 'Sol',
  
  // Classic chocobo-style names with 'o' endings
  'Rico', 'Nico', 'Pico', 'Taco', 'Roco', 'Soco', 'Vico', 'Zico', 'Deco', 'Neco',
  'Foco', 'Goco', 'Hoco', 'Joco', 'Toco', 'Yoco', 'Beco', 'Ceco', 'Leco', 'Reco',
  
  // Traditional with 'y' endings  
  'Chocy', 'Boky', 'Smoky', 'Poky', 'Cozy', 'Rosy', 'Nosy', 'Mozy', 'Dozy', 'Tozy',
  'Frisky', 'Whisky', 'Husky', 'Dusky', 'Misty', 'Dusty', 'Rusty', 'Gusty', 'Frosty', 'Crusty',
  
  // Short and sweet traditional
  'Pip', 'Pop', 'Pep', 'Bip', 'Bop', 'Zap', 'Zip', 'Zop', 'Tip', 'Top',
  'Cup', 'Cap', 'Cop', 'Cip', 'Dip', 'Dop', 'Hip', 'Hop', 'Hup', 'Hap',
  
  // Classic FF-inspired but traditional sounding
  'Gysahl', 'Sylkis', 'Reagan', 'Mimett', 'Curiel', 'Pahsana', 'Tantal', 'Krakka',
  'Gysahli', 'Sylkie', 'Reagy', 'Mimo', 'Curie', 'Pasha', 'Tanty', 'Krakky',
  
  // Playful traditional variations
  'Chocky', 'Chucky', 'Checky', 'Chicky', 'Cheeky', 'Chirpy', 'Choppy', 'Chatty',
  'Bouncy', 'Prancy', 'Skippy', 'Nippy', 'Peppy', 'Snappy', 'Happy', 'Sappy',
  
  // Simple sound variations
  'Kwee', 'Kwoo', 'Kwaa', 'Kwii', 'Waa', 'Woo', 'Wee', 'Wii', 'Koo', 'Kaa',
  'Baa', 'Bee', 'Boo', 'Bii', 'Maa', 'Mee', 'Moo', 'Mii', 'Naa', 'Noo'
]

export class ChocoboFactory {
  // Static property to track recently used names
  static recentNames = new Set()
  static maxRecentNames = 100 // Track last 100 names to avoid duplicates
  static nameHistory = [] // Keep order for efficient cleanup
  
  static generateRandomName() {
    let attempts = 0
    let name
    
    // Try to generate a unique name, with fallback after multiple attempts
    do {
      // 30% chance of traditional name, 70% chance of compound name
      if (Math.random() < 0.3) {
        name = TRADITIONAL_NAMES[Math.floor(Math.random() * TRADITIONAL_NAMES.length)]
      } else {
        const prefix = CHOCOBO_PREFIXES[Math.floor(Math.random() * CHOCOBO_PREFIXES.length)]
        const suffix = CHOCOBO_SUFFIXES[Math.floor(Math.random() * CHOCOBO_SUFFIXES.length)]
        
        // 50% chance to capitalize suffix
        const formattedSuffix = Math.random() < 0.5 
          ? suffix.charAt(0).toUpperCase() + suffix.slice(1)
          : suffix
        
        // 30% chance to add space between words
        name = Math.random() < 0.3 
          ? `${prefix} ${formattedSuffix}`
          : `${prefix}${formattedSuffix}`
      }
      
      attempts++
      
      // After 10 attempts, clear some recent names and allow duplicates
      if (attempts >= 10) {
        this.clearOldNames(50) // Clear half the recent names
        break
      }
    } while (this.recentNames.has(name))
    
    // Add the name to recent tracking
    this.addToRecentNames(name)
    
    return name
  }
  
  static addToRecentNames(name) {
    // Add to both Set (for fast lookup) and Array (for order tracking)
    this.recentNames.add(name)
    this.nameHistory.push(name)
    
    // If we exceed the limit, remove the oldest names
    if (this.nameHistory.length > this.maxRecentNames) {
      const toRemove = this.nameHistory.splice(0, this.nameHistory.length - this.maxRecentNames)
      toRemove.forEach(oldName => this.recentNames.delete(oldName))
    }
  }
  
  static clearOldNames(count = 25) {
    // Remove the oldest 'count' names from tracking
    const toRemove = this.nameHistory.splice(0, Math.min(count, this.nameHistory.length))
    toRemove.forEach(oldName => this.recentNames.delete(oldName))
  }
  
  static resetNameTracking() {
    // Utility method to completely reset name tracking (useful for testing)
    this.recentNames.clear()
    this.nameHistory = []
  }

  static calculateColorRegionProbabilities(excludeStableBorn = false) {
    const probabilities = []
    
    // Calculate total weight (inverse of xfactor_percentage)
    let totalWeight = 0
    
    for (const [color, regions] of Object.entries(CHOCOBO_BASE_STATS)) {
      for (const [region, stats] of Object.entries(regions)) {
        // Skip region7 (Stable Born) if excludeStableBorn is true
        if (excludeStableBorn && region === 'region7') {
          continue
        }
        
        // Using inverse of xfactor_percentage as weight
        // Higher xfactor = lower chance of appearing
        const weight = 1 / (stats.xfactor_percentage / 100)
        totalWeight += weight
        
        probabilities.push({
          color,
          region,
          weight,
          stats
        })
      }
    }
    
    // Convert weights to cumulative probabilities
    let cumulativeWeight = 0
    probabilities.forEach(prob => {
      cumulativeWeight += prob.weight
      prob.cumulativeProbability = cumulativeWeight / totalWeight
    })
    
    return probabilities
  }

  static selectColorAndRegion(probabilities) {
    const random = Math.random()
    
    // Find the first probability that exceeds our random number
    const selected = probabilities.find(prob => prob.cumulativeProbability >= random)
    
    return {
      color: selected.color,
      region: selected.region
    }
  }

  static generateRandomChocobo(currentDay = 1) {
    const probabilities = this.calculateColorRegionProbabilities()
    const { color, region } = this.selectColorAndRegion(probabilities)
    const name = this.generateRandomName()
    
    const chocobo = new Chocobo(color, region, name)
    chocobo.birthDay = currentDay
    return chocobo
  }
  static generateHighLevelChocobo(minLevel, maxLevel, currentDay = 1) {
    const probabilities = this.calculateColorRegionProbabilities()
    const { color, region } = this.selectColorAndRegion(probabilities)
    const name = this.generateRandomName()
    
    const chocobo = new Chocobo(color, region, name)
    chocobo.birthDay = currentDay
    
    // Set level and apply appropriate experience
    const targetLevel = Math.floor(Math.random() * (maxLevel - minLevel + 1)) + minLevel
    const requiredExp = (targetLevel - 1) * 100
    
    // Simulate level-ups to get appropriate stat gains
    while (chocobo.level < targetLevel) {
      chocobo.gainExperience(100)
    }
    
    return chocobo
  }

  static generateInitialChocobos(count = 850) {
    const probabilities = this.calculateColorRegionProbabilities(true) // Exclude stable born for initial chocobos
    const chocobos = []
    const usedNames = new Set()
    const distribution = {}

    // Generate base level chocobos (250)
    for (let i = 0; i < 150; i++) {
      let name
      do {
        name = this.generateRandomName()
      } while (usedNames.has(name))
      
      usedNames.add(name)
      
      const { color, region } = this.selectColorAndRegion(probabilities)
      const chocobo = new Chocobo(color, region, name)
      chocobo.birthDay = 1 // Initial chocobos are all "born" on day 1
      chocobos.push(chocobo)

      // Track distribution
      const key = `${color}-${region}`
      distribution[key] = (distribution[key] || 0) + 1
    }

    // Generate mid-tier chocobos (Level 10-20) - 100 chocobos
    for (let i = 0; i < 100; i++) {
      let name
      do {
        name = this.generateRandomName()
      } while (usedNames.has(name))
      
      usedNames.add(name)
      const chocobo = this.generateHighLevelChocobo(10, 20)
      chocobos.push(chocobo)
    }

    // Generate high-tier chocobos (Level 21-30) - 100 chocobos
    for (let i = 0; i < 150; i++) {
      let name
      do {
        name = this.generateRandomName()
      } while (usedNames.has(name))
      
      usedNames.add(name)
      const chocobo = this.generateHighLevelChocobo(21, 30)
      chocobos.push(chocobo)
    }

    // Generate elite chocobos (Level 31-40) - 50 chocobos
    for (let i = 0; i < 50; i++) {
      let name
      do {
        name = this.generateRandomName()
      } while (usedNames.has(name))
      
      usedNames.add(name)
      const chocobo = this.generateHighLevelChocobo(31, 40)
      chocobos.push(chocobo)
    }

    // Level distribution logging
    const levelDist = chocobos.reduce((acc, chocobo) => {
      const levelRange = chocobo.level <= 1 ? '1' :
                        chocobo.level <= 10 ? '2-10' :
                        chocobo.level <= 20 ? '11-20' :
                        chocobo.level <= 30 ? '21-30' :
                        '31-40';
      acc[levelRange] = (acc[levelRange] || 0) + 1;
      return acc;
    }, {});

    return chocobos
  }

  // Update distributeChocobosToOwners in game store
  static distributeChocobosToOwners(chocobos, owners, playerOwner) {
    // Filter starter chocobos to only include those from player's home region
    const regionChocobos = chocobos.filter(c => 
      c.level === 1 && c.region === playerOwner.homeRegion
    )
  
    if (regionChocobos.length < 2) {
      throw new Error(`Not enough starter chocobos in region ${playerOwner.homeRegion}`)
    }
  
    // Give player 2 starter chocobos from their region
    const starterChocobos = regionChocobos
      .sort(() => Math.random() - 0.5)
      .slice(0, 2)
    
    starterChocobos.forEach(chocobo => {
      playerOwner.chocoboIds.push(chocobo.id)
    })
  
    // Distribute remaining chocobos based on owner traits
    const remainingChocobos = chocobos.filter(c => 
      !starterChocobos.find(sc => sc.id === c.id)
    )
  
    // Sort owners by their traits
    const npcOwners = owners.filter(owner => !owner.isPlayer)
      .sort((a, b) => 
        (b.ambition + b.competitiveness) - (a.ambition + a.competitiveness)
      )
  
    // Give higher level chocobos to more competitive owners
    remainingChocobos.sort((a, b) => b.level - a.level)
    
    let currentOwnerIndex = 0
    remainingChocobos.forEach(chocobo => {
      npcOwners[currentOwnerIndex].chocoboIds.push(chocobo.id)
      currentOwnerIndex = (currentOwnerIndex + 1) % npcOwners.length
    })
  }
}
